<template>
  <div class="past-incidents">
    <h3>Incidentes Resolvidos</h3>
    <div class="resolved-incidents-container">
      <div class="resolved-header">
        <div class="w-48">Data</div>
        <div class="flex-1">Título</div>
        <div class="w-32">Duração</div>
        <div class="w-32">Status</div>
      </div>

      <div class="resolved-list divide-y divide-gray-100">
        <div v-if="loading" class="loading">
          <div class="spinner"></div>
          <span>Carregando incidentes...</span>
        </div>
        <div v-else-if="resolvedIncidents.length === 0" class="no-incidents">
          Nenhum incidente resolvido recentemente.
        </div>
        <div v-else v-for="(incident, index) in resolvedIncidents" :key="incident.id">
          <div class="resolved-item" @click="toggleResolvedTimeline(index)">
            <div class="w-48">{{ formatDate(incident.created_at) }}</div>
            <div class="flex-1">{{ incident.title }}</div>
            <div class="w-32">{{ incident.duration }}</div>
            <div class="w-32"><div class="badge -success">Resolvido</div></div>
          </div>
          <transition name="fade">
            <div v-show="incident.showTimeline" class="timeline-container">
              <div class="incident-timeline">
                <template v-if="incident.messages && incident.messages.length">
                  <div v-for="(message, msgIndex) in incident.messages" :key="msgIndex" class="timeline-item">
                    <div class="time">{{ formatDate(message.date) }}</div>
                    <div class="status-badge" :class="message.statusClass">{{ translateStatus(message.status) }}</div>
                    <div class="message">{{ message.text }}</div>
                  </div>
                </template>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import statusMixin from '../mixins/statusMixin';

export default {
  name: 'ResolvedIncidents',
  mixins: [statusMixin],

  computed: {
    ...mapState({
      resolvedIncidents: (state) => state.status.resolvedIncidents,
      loading: (state) => state.status.loading,
    }),
  },

  methods: {
    ...mapMutations({
      toggleResolvedTimeline: 'status/toggleResolvedTimeline',
    }),

    formatDate(date) {
      return new Date(date).toLocaleString('pt-BR');
    },
  },
};
</script>

<style lang="scss" scoped>
.past-incidents {
  margin-left: -10px;
  margin-right: -10px;
  @apply mt-8;

  h3 {
    @apply text-lg;
    @apply font-semibold;
    @apply mb-4;
  }
}

.resolved-incidents-container {
  width: 100%;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.resolved-header {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  font-weight: 500;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f9fafb;
}

.resolved-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f9fafb;
  }
}

.timeline-container {
  padding: 0.75rem 1rem;
  border-top: 1px solid #f3f4f6;
  background-color: #f9fafb;
}

.incident-timeline {
  .timeline-item {
    @apply mb-1;
    @apply flex;
    @apply items-start;
    @apply pl-4;
    @apply border-l-2;
    @apply border-gray-200;
    @apply text-sm;

    .time {
      @apply text-gray-500;
      min-width: 150px;
      margin-right: 1rem;
    }

    .status-badge {
      min-width: 120px;
      margin-right: 1rem;
    }

    .message {
      @apply flex-1;
    }

    &:last-child {
      @apply mb-0;
    }
  }
}

.badge {
  @apply px-3;
  @apply py-1;
  @apply rounded-full;
  @apply text-sm;
  @apply font-medium;

  &.-success {
    @apply bg-green-100;
    @apply text-green-800;
  }
}

.no-incidents {
  @apply text-center;
  @apply py-8;
  @apply text-gray-500;
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
  opacity: 1;
}

.fade-enter, .fade-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
</style>
